import React from 'react';
import { getGlobalWindowVariables } from 'utils/globalWindowVariables';
import {
    useSelectBuildVersion,
    useSelectIsAppModeStandalone,
} from 'app/store/general/selectors';
import InfoBox from 'utils/components/InfoBox/InfoBox';

import { MessageIcon } from '@instinet-analytics/semantic-ui-components';
import { Tooltip } from '@instinet-analytics/core-lib';

import './OutdatedIndigoVersion.scss';
import { useDisplayingOutdatedIndigoVersionWarning } from 'app/OutdatedIndigoVersion/hooks';

export function OutdatedIndigoVersion({ iconView }: { iconView?: boolean }) {
    const displayWarning = useDisplayingOutdatedIndigoVersionWarning();

    const globals = getGlobalWindowVariables();
    const isStandalone = useSelectIsAppModeStandalone();

    /*
     * Retrieved from server when the availability status became ready
     */
    const buildVersion = useSelectBuildVersion();

    if (!displayWarning) {
        return <></>;
    }
    /*
     * Current version running in the browser
     */
    const runningBuildVersion = globals.buildVersion;

    const instruction = isStandalone
        ? 'Please refresh your browser'
        : 'Please reload the panel';
    const messagePrefix = isStandalone ? '' : 'Indigo ';

    const tooltip = `Your Indigo version '${runningBuildVersion}' differs from the latest server version '${buildVersion}'. ${instruction}.`;

    if (iconView) {
        return (
            <Tooltip className="OutdatedIndigoVersion view-icon" text={tooltip}>
                <MessageIcon title={tooltip} />
            </Tooltip>
        );
    }
    return (
        <div className="OutdatedIndigoVersion">
            <InfoBox
                tooltip={tooltip}
                info={messagePrefix + 'Version Mismatch'}
                isWarning={true}
            />
        </div>
    );
}
